import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import PopoverModal from './popover_modal';
import OutsideClickNotifier from './outside_click_notifier';

const PopoverWrapper = styled.span`
  cursor: pointer;
  width: fit-content;
  background: none;
  border: none;
`;

const Popover = props => {
  const [open, setOpen] = useState(!!props.open);
  const buttonRef = useRef(null);
  const toggleOpen = () => setOpen(!open);

  return (
    <span id={props.rootId}>
      <PopoverWrapper onClick={toggleOpen} innerRef={buttonRef}>
        {props.rootEl}
      </PopoverWrapper>
      {open && (
        <OutsideClickNotifier toggleOpen={toggleOpen} buttonRef={buttonRef}>
          <PopoverModal
            modalStyles={props.modalStyles}
            arrowStyles={props.arrowStyles}
            noArrow={props.noArrow}
            rootId={props.rootId}
            open={open}
            toggleOpen={toggleOpen}
          >
            {props.children}
          </PopoverModal>
        </OutsideClickNotifier>
      )}
    </span>
  );
};

export default Popover;
